
import axiosClient from '../axiosClient';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Shared blob downloader
const downloadBlob = async (url, filename) => {
  const authToken = localStorage.getItem('auth_token') ||
                   sessionStorage.getItem('auth_token');

  const response = await fetch(url, {
    method: 'GET',
    headers: authToken ? { 'Authorization': `Bearer ${authToken}` } : {},
    credentials: 'include',
  });
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(objectUrl); }, 100);
};

export const allInvoiceApi = {
  getAllInvoices: async (page = 0, size = 20, search = '', month = '', status = '', sortBy = '', sortOrder = 'desc', year = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      if (search && search.trim() !== '') params.append('search', search.trim());
      if (month && month.trim() !== '') params.append('month', month.trim());
      if (status && status.trim() !== '') params.append('status', status.trim());
      if (year && year.toString().trim() !== '') params.append('year', year.toString().trim());
      if (sortBy && sortBy.trim() !== '') {
        params.append('sortBy', sortBy.trim());
        params.append('sortOrder', sortOrder);
      }
      console.log('📦 Fetching all invoices with params:', params.toString());
      const data = await axiosClient.get(`/all-invoices?${params.toString()}`);
      console.log('📦 All Invoices API data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching all invoices:', error);
      throw error;
    }
  },

  exportAllInvoices: async (search = '', month = '', status = '', year = '') => {
    try {
      const params = new URLSearchParams();
      if (search && search.trim() !== '') params.append('search', search.trim());
      if (month && month.trim() !== '') params.append('month', month.trim());
      if (status && status.trim() !== '') params.append('status', status.trim());
      if (year && year.toString().trim() !== '') params.append('year', year.toString().trim());
      console.log('📊 Exporting all invoices with params:', params.toString());
      return await axiosClient.get(`/all-invoices/export?${params.toString()}`);
    } catch (error) {
      console.error('Error exporting all invoices:', error);
      throw error;
    }
  },

  getInvoiceLineDetails: async (invoiceNo, lineNum) => {
    try {
      console.log('🔍 Fetching invoice line details for:', invoiceNo, 'Line:', lineNum);
      return await axiosClient.get(`/all-invoices/${invoiceNo}/${lineNum}`);
    } catch (error) {
      console.error('Error fetching invoice line details:', error);
      throw error;
    }
  },

  getInvoiceYears: async () => {
    try {
      console.log('📅 Fetching available invoice years...');
      const data = await axiosClient.get(`/all-invoices/years`);
      console.log('📅 Available years:', data);
      return data;
    } catch (error) {
      console.error('Error fetching invoice years:', error);
      throw error;
    }
  },

  // Check if Invoice PDF exists
  checkInvoicePdfExists: async (invoiceNo) => {
    try {
      const response = await axiosClient.get(`/invoice/check-pdf/${invoiceNo}`);
      if (response && typeof response === 'object' && 'exists' in response) {
        return { exists: response.exists === true };
      }
      return { exists: false };
    } catch {
      return { exists: false };
    }
  },

  // Download Invoice PDF
  downloadInvoicePdf: async (invoiceNo) => {
    await downloadBlob(
      `${API_URL}/api/invoice/download-pdf/${invoiceNo}`,
      `Invoice_${invoiceNo}(Signed).pdf`
    );
  },

  // Download COA - density (LOCAL source)
  downloadDensityCoa: async (itemCode, batchNumber) => {
    await downloadBlob(
      `${API_URL}/api/density-coa/download-by-item/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNumber)}`,
      `COA_${itemCode}_${batchNumber}.pdf`
    );
  },

  // Download COA - energy (ENERGY source)
  downloadEnergyCoa: async (itemCode, batchNumber) => {
    await downloadBlob(
      `${API_URL}/api/coa/download-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNumber)}`,
      `COA_${itemCode}_${batchNumber}.pdf`
    );
  },
};